import { Box, Text, VStack, Button, Icon } from '@chakra-ui/react';
import { FiMicOff, FiRefreshCw } from 'react-icons/fi';

interface PermissionDeniedProps {
  onRetry: () => void;
}

function PermissionDenied({ onRetry }: PermissionDeniedProps) {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      right="0"
      bottom="0"
      bg="white"
      borderRadius="16px"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding="32px"
      textAlign="center"
    >
      <VStack spacing="24px" maxW="280px">
        <Box bg="red.50" borderRadius="50%" p="16px" display="flex" alignItems="center" justifyContent="center">
          <Icon as={FiMicOff} boxSize="32px" color="red.500" />
        </Box>

        <Text fontSize="18px" fontWeight="700" color="gray.800" lineHeight="24px">
          Permissão do microfone negada
        </Text>

        <VStack spacing="12px">
          <Text fontSize="14px" color="gray.600" lineHeight="20px">
            Para usar a transcrição por áudio, você precisa permitir o acesso ao microfone.
          </Text>

          <Text fontSize="14px" color="gray.600" lineHeight="20px">
            Clique no ícone do cadeado na barra de endereços e permita o acesso ao microfone.
          </Text>
        </VStack>

        <Button
          onClick={onRetry}
          bg="purple.600"
          color="white"
          size="md"
          borderRadius="12px"
          px="24px"
          py="12px"
          fontSize="14px"
          fontWeight="600"
          leftIcon={<Icon as={FiRefreshCw} />}
          _hover={{
            bg: 'purple.700',
          }}
          _active={{
            bg: 'purple.800',
          }}
        >
          Tentar novamente
        </Button>

        <Box bg="gray.50" borderRadius="8px" p="12px" fontSize="12px" color="gray.500" lineHeight="16px">
          <Text fontWeight="600" mb="4px">
            💡 Dica:
          </Text>
          <Text>Após permitir o acesso, clique em "Tentar novamente" para continuar.</Text>
        </Box>
      </VStack>
    </Box>
  );
}

export { PermissionDenied };
